import { createApp } from 'vue'
import App from './App.vue'
import { createStudioI18n } from './i18n/index.js'
import { createStudioRouter } from './router/index.js'
import { createVisualGameStudioClient } from './api/client.js'
import '@drama/ui/theme.css'
import './theme/vg-studio.css'
import { applyStudioTheme, readStoredTheme } from './composables/useStudioTheme.js'

const baseUrl = /** @type {any} */ (import.meta).env?.VITE_API_BASE_URL ?? '/'
const initialLocale = /** @type {any} */ (import.meta).env?.VITE_LOCALE ?? 'zh'

applyStudioTheme(readStoredTheme())

const i18n = createStudioI18n({ locale: initialLocale })
const api = createVisualGameStudioClient({
  baseUrl,
  getLocale: () => i18n.getLocale(),
})
const router = createStudioRouter({ api })

const app = createApp(App)
app.provide('api', api)
app.provide('i18nRuntime', i18n)
app.use(i18n.i18n)
app.use(router)
// 语言包到位再挂载，否则首屏先闪一帧英文
i18n.ready.then(() => app.mount('#app'))
